module.exports = __webpack_public_path__ + "static/media/coffee-togo.4d9a9238.svg";